import { CurrentUser } from '@shared/model/current-user';

export type CurrentUserDataResponse = CurrentUser;

export enum CurrentUserInfoEnum {
    UTM = 'utm',
}

export enum UTMInfoKeysEnum {
    UTMSource = 'utm_source',
    UTMTerm = 'utm_term',
    UTMContent = 'utm_content',
    UTMedium = 'utm_medium',
    UTMCampaign = 'utm_campaign',
    Date = 'date',
    Referer = 'referer',
    Transferer = 'transferer',
    LKProduct = 'lk_product',
}

export interface CurrentUserInfo {
    userId: number;
    type: CurrentUserInfoEnum;
    data: Partial<Record<UTMInfoKeysEnum, string>>;
}
